/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { OauthconnectionsItemRequestBuilderRequestsMetadata, type OauthconnectionsItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /oauthconnections
 */
export interface OauthconnectionsRequestBuilder extends BaseRequestBuilder<OauthconnectionsRequestBuilder> {
    /**
     * Gets an item from the ApiSdk.oauthconnections.item collection
     * @param id Unique identifier of the item
     * @returns {OauthconnectionsItemRequestBuilder}
     */
     byId(id: Guid) : OauthconnectionsItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const OauthconnectionsRequestBuilderUriTemplate = "{+baseurl}/oauthconnections";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const OauthconnectionsRequestBuilderNavigationMetadata: Record<Exclude<keyof OauthconnectionsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        requestsMetadata: OauthconnectionsItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["id"],
    },
};
/* tslint:enable */
/* eslint-enable */
